import Entity from './entity'

export default class BinDetail extends Entity<number>{
    code:string;
    warehouseCode :string;
    level : number;
    aisleCode :string;
    roomCode :string;
    binTypeCode :string;
    binTypeName : string;
    length :number;
    width :number;
    height :number;
    vol :number;
    maxNumOfSKU : string;
    lastModificationTime: Date;
    lastModifierUserId: number;
    lastModifierUserName: string;
}